import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { NavLink, Link } from 'react-router-dom'

import sidebarMenu from './menu'

import logo from '../../assets/images/Logo.png'
import avatar from '../../assets/images/avatar.png'
import merchantApi from '../../services/merchantApi'
import { Icon } from '@iconify/react/dist/iconify.js'
import { Avatar } from '@mui/material'

// ─── Sidebar ──────────────────────────────────────────────────────────────────

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [currentOutlet, setCurrentOutlet] = useState()
  const [collapsed, setCollapsed] = useState(false)
  const [userInfo, setUserInfo] = useState(false)
  const [outletList, setOutletList] = useState([])
  const [switchingOutlet, setSwitchingOutlet] = useState(false)
  const [orderOpenNum, setOrderOpenNum] = useState(0)

  useEffect(() => {
    const loadData = async () => {
      try {
        const userInfoResponse = await merchantApi.auth.me();
        setUserInfo(userInfoResponse?.data || null)
        setCurrentOutlet(userInfoResponse?.data?.default_outlet || null)
        setOutletList(userInfoResponse?.data?.outlets || [])
      } catch (error) {
        console.log("Error fetching data:", error)
      }

    }
    loadData()
    loadGeneralInfo()
  }, [])

  const loadGeneralInfo = async () => {
    try {
      const response = await merchantApi.general.systemInfo();
      console.log("General info:", response?.data)
      setOrderOpenNum(response?.data?.orders?.open_orders || 0)
    } catch (error) {
      console.log("Error fetching general info:", error)
    }
  }

  const handleLogout = async () => {
    try {
      await merchantApi.auth.logout()
      window.location.href = '/login'
    } catch (error) {
      console.log("Error logging out:", error)
    }
  }
  console.log(userInfo?.profile_photo_url ? 'have photo' : 'no photo')
  return (
    <>
      <aside className={[
        'sidebar',
        sidebarOpen ? 'sidebar--open' : '',
        collapsed ? 'sidebar--collapsed' : '',
      ].filter(Boolean).join(' ')}>

        {/* ── HEADER ── */}
        <div className="sidebar__header">
          {!collapsed && (
            <div className="flex-container">
              <img src={userInfo?.merchant?.logo_url || logo} alt="Cuscapi" className="sidebar__avatar" />
              <span className="sidebar__merchant">{'Cuscapi'}</span>
            </div>
          )}

          {/* Collapse toggle */}
          <button
            className="sidebar__collapse-btn"
            onClick={() => setCollapsed((v) => !v)}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed
              ? <Icon icon="ph:caret-double-right" height={16} />
              : <Icon icon="ph:caret-double-left" height={16} />
            }
          </button>
        </div>

        {/* ── NAV ── */}
        <nav className="sidebar__nav">
          {sidebarMenu.map((group) => (
            <div className="sidebar__group" key={group.title}>
              {!collapsed && (
                <p className="sidebar__group-title">{group.title}</p>
              )}
              {collapsed && <div className="sidebar__group-divider" />}

              <div className="sidebar__menu">
                {group.items.map((item) => {
                  return (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={'sidebar__item sidebar__item--active'}
                      onClick={() => setSidebarOpen(false)}
                      title={collapsed ? item.label : undefined}
                    >
                      <Icon icon={item.icon} width={18} height={18} className="sidebar__item-icon" />
                      {!collapsed && (
                        <span className="sidebar__item-label">{item.label}</span>
                      )}
                      {Boolean(item.label === 'Orders' && orderOpenNum && !collapsed) && (
                        <span className="sidebar__badge badge badge--primary">{orderOpenNum}</span>
                      )}
                      {Boolean(item.label === 'Orders' && orderOpenNum && collapsed) && (
                        <span className="sidebar__badge sidebar__badge--dot" />
                      )}
                    </NavLink>
                  )
                })}
              </div>
            </div>
          ))}
        </nav>

        {/* ── FOOTER ── */}
        <div className="sidebar__footer">
          {!collapsed ? (
            <>
              <Link to="/profile" className="sidebar__profile">
                {
                  userInfo?.profile_photo_url ?
                    <Avatar src={userInfo?.profile_photo_url || avatar} alt="User" className="sidebar__avatar" />
                    : <Avatar className="sidebar__avatar" />
                }
                <span className="sidebar__name">{userInfo?.name || 'User'}</span>
              </Link>
              <div className="sidebar__logout" onClick={() => handleLogout()}>
                <Icon icon="ph:sign-out" height={16} />
                Logout
              </div>
            </>
          ) : (
            <>
              {
                userInfo?.profile_photo_url ?
                  <Avatar src={userInfo?.profile_photo_url} alt="User" className="sidebar__avatar sidebar__avatar--center" title={userInfo?.name || 'User'} />
                  : <Avatar className="sidebar__avatar" src={userInfo?.profile_photo_url}/>
              }

              <button className="sidebar__logout sidebar__logout--icon" title="Logout">
                <Icon icon="ph:sign-out" height={16} />
              </button>
            </>
          )}
        </div>
      </aside>

    </>
  )
}